export const CoOpSetting = {
  properties: {
    BidOption: {
      'bulk-upload-header': 'Bid Option',
    },
    BidBoostValue: {
      'bulk-upload-header': 'Bid Boost Value',
    },
    BidMaxValue: {
      'bulk-upload-header': 'Maximum Bid',
    },
  },
};
